import {useEffect} from 'react';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import { useReduxToken } from '@Hooks/reduxTokenHook/useReduxToken';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';
import ErrorHandler from '@Root/ErrorHandler';

export default function useSessionCheck() {

    const { token } = useReduxToken();
    const { setActiveUserPermission, activeUserAccessList, setActiveUserAccessList, userType } = useReduxActiveUser();
    const userAuthService = new UserAuthService();
    new ErrorHandler();

    useEffect(() => {
        let interval;
        if(userType === 'admin') {
            interval = setInterval(() => {
                if(!!token) {
                    sessionAndPermissionCheck();
                }
            }, 30000);
        }
        return () => {
            clearInterval(interval);
        }
    }, []);

    const sessionAndPermissionCheck = async()=> {
        let apcAppVersion = !!localStorage.getItem('KZQ_RESOLVE_VERSION') ? localStorage.getItem('KZQ_RESOLVE_VERSION') : '0';
        let modifiedTimeStamp = !!activeUserAccessList.modifiedTimeStamp ? activeUserAccessList.modifiedTimeStamp : 0;
        let bodyObj = {
            appVersion: apcAppVersion,
            modifiedTimeStamp: modifiedTimeStamp
        }
        let sessionCheckReturn = await userAuthService.sessionAndPermissionCheck(bodyObj);
        if(!sessionCheckReturn?.status) return;
        if(sessionCheckReturn.status == 200) {
            sessionCheckReturn = JSON.parse(sessionCheckReturn.body);
            if(!!sessionCheckReturn.session) {
                setSessionsToLocalStorage(sessionCheckReturn.session);
            }
            if(!!sessionCheckReturn.accessList) {
                setActiveUserAccessList(sessionCheckReturn.accessList);
            }
            if(!!sessionCheckReturn.permissions) {
                setActiveUserPermission(sessionCheckReturn.permissions);
            }
        }
    }

    const setSessionsToLocalStorage = (sessionCheckReturn)=> {
        localStorage.setItem("KZQ_RESOLVE_VERSION", sessionCheckReturn?.KZQ_RESOLVE_VERSION ?? JSON.parse(localStorage.token).KZQ_RESOLVE_VERSION);
    }
}